module.exports = __webpack_public_path__ + "img/2.6bf518f3.png";